import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'Daywisestockreport',
	components: {
		BasicSelect,
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader
	},
	props: [],
	data() {
		return {
			// totalRows:0,
			// currentPage: 0,
			selectedmerchant:{value:'',text:''},
			merchantList:[],
			reportname: '',
			csvFieldsForXls: {},
      listStockReportDataforxls:[],
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			pageLimit:10,
			listStockReportData: [],
			listStockReportDatacsv: [],
			listStockReportFinalData: [],
			csvFields: [],
			// pageno: 0,
			// totalPage: 0,
			ProductID: '',
			isLoading: false,
			formattedDate: '',
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectMerchant:false,
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			stockcheckdate: '',
			DateError: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
     		recordLimit: 0,
			listMerchantData:[],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			activemrpflag:false,
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.userid = userdetail.userid;
		this.reportname = this.$t('editedjson.stockReportDayWise');
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getStockReportData();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectMerchant =true;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.getActiveMrpFlag();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant =true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		selectMerchant(data){
			this.selectedmerchant = data;
			this.merchant = data.value;
		  },
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload(){
		this.isLoadingforxls =true;
		},
		finishDownload(){
		this.isLoadingforxls =false;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getStockReportDataForXLS(3)

			}
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client  ||this.clientid == this.client ) {
		// 		this.clientid = this.client;
		// 		this.getMerchantList();
		// 		this.merchant='';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.merchantList=[]
		// 			this.selectedmerchant={}
		// 			this.getWarehouseList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.merchantList=[]
		// 			this.selectedmerchant={}
		// 			this.getActiveMrpFlag();
		// 			// this.getStockReportData();
		// 		}
		// 	}
		// 	this.listStockReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getStockReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem('selectedClient'),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getStockReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getStockReportData(2);
		},
		//to get client list
		getStockReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var stockcheckdate = '';
			if (csvCheck == 2){
				this.show=false;
				this.download =true;
					this.limitExeed = false;
			}
			// this.ClientErr = '';
			var dataFilter = {};
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}

			if (this.stockcheckdate) {
				stockcheckdate = this.dateFormat(this.stockcheckdate)
			} else {
				this.DateError = this.$t('common.dateReqError');
				this.listStockReportData = [];
				return false;
			}

			var today = new Date(moment().format('YYYY-MM-DD 23:59:59'));
			var stockcheckdateFormated = new Date(this.stockcheckdate);

			if (Date.parse(stockcheckdateFormated) > Date.parse(today)) {
				this.$alertify.error(this.$t('reports.selectDateError'));
				this.listStockReportData = [];
				return false;
			}
			this.isLoading = true;

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
				warehouseid: localStorage.getItem('selectedWarehouse'),
				productid: this.ProductID,
				date: stockcheckdate,
				offset:(this.currentPage - 1) * 10,
				limit: 10,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
  })
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'dayWiseStockReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listStockReportDataCsv = [];
							this.csvFields = {
								'clientproductid': this.$t('product.clientProductId'),
								'productid': this.$t('product.productId'),
								'productname': this.$t('product.productName'),
								'brand': this.$t('common.brand'),
								'mrp': this.$t('product.table.columns.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'previous_day_stock': this.$t('daywiseatpstock.totalopeningstock'),
								'today_rackin': this.$t('daywiseatpstock.todaystockin'),
								'today_allocation': this.$t('daywiseatpstock.todaystockout'),
								'current_stock': this.$t('daywiseatpstock.currentstock'),
								'merchantname':this.$t('packingReportList.table.columns.merchantName')
							};
							var dateFilter = [];
							if(this.activemrpflag === true){
									var skipFilter = [];
							}else {
									var skipFilter = ['activerp'];
							}
							this.listStockReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('editedjson.stockReportDayWise'), this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('StockReportDayWise', this.listStockReportDataCsv, this.csvFields, dateFilder, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listStockReportData = result.data.data
						if (result.data.errorCode == -1 || result.data.errorCode == 1) {
							this.resultCount = 0
							this.totalRows = 0
						} else {
							this.totalRows = result.data.count
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		getStockReportDataForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var stockcheckdate = '';
			// this.ClientErr = '';
			this.show = true;
      this.download = false;
			this.dataFilter2 = [];
      var value = '';
      var str = '';
			var dataFilter = {};

			if (this.stockcheckdate) {
				stockcheckdate = this.dateFormat(this.stockcheckdate)
			} else {
				this.DateError = this.$t('common.dateReqError');
				this.listStockReportData = [];
				return false;
			}

			var today = new Date(moment().format('YYYY-MM-DD 23:59:59'));
			var stockcheckdateFormated = new Date(this.stockcheckdate);

			if (Date.parse(stockcheckdateFormated) > Date.parse(today)) {
				this.$alertify.error(this.$t('reports.selectDateError'));
				this.listStockReportData = [];
				return false;
			}

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
				warehouseid: localStorage.getItem('selectedWarehouse'),
				productid: this.ProductID,
				date: stockcheckdate,
				offset:(this.currentPage - 1) * 10,
				limit: 10,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'dayWiseStockReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listStockReportDataforxls = [];
								this.csvFieldsForXls =[];
								this.csvFieldsForXls[this.$t('product.clientProductId')] =  'clientproductid';
								this.csvFieldsForXls[this.$t('packingReportList.table.columns.merchantName')] = 'merchantname';
								this.csvFieldsForXls[this.$t('product.productId')] ='productid';
								this.csvFieldsForXls[this.$t('product.productName')] = 'productname';
								this.csvFieldsForXls[this.$t('common.brand')] = 'brand';
								this.csvFieldsForXls[this.$t('product.table.columns.mrp')] =  'mrp';
								if(this.activemrpflag === true){
								 this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							  }
								this.csvFieldsForXls[this.$t('daywiseatpstock.totalopeningstock')] =  'previous_day_stock';
								this.csvFieldsForXls[this.$t('daywiseatpstock.todaystockin')] = 'today_rackin';
								this.csvFieldsForXls[this.$t('daywiseatpstock.todaystockout')] = 'today_allocation';
								this.csvFieldsForXls[this.$t('daywiseatpstock.currentstock')] =  'current_stock';
								this.listStockReportDataforxls = result.data.data;
							}
							else {
									if (result.data.status == true) {
										this.$alertify.success(this.$t('common.reportSizeError'));
									} else {
										this.$alertify.error(result.data.msg.message);
									}
								}


					}

				}, error => {
					console.error(error)
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getStockReportData();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getStockReportData()
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.ProductID = '';
			this.stockcheckdate = '';
			this.merchant='';
			this.pageno = 0;
			this.totalRows =0;
			this.listStockReportData = [];
			this.searchFlag = false;
			this.selectedmerchant={}
			// this.merchantList=[]
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.merchantList.push({
							value:'',text: this.$t('common.selectMerchantPlaceHolder')}
					   )
						for (var i = 0; i < this.listMerchantData.length; i++) {
							// console.log( this.listMerchantData.merchantname[i],"merchname")
							this.merchantList.push({
							  'value': this.listMerchantData[i].merchantid,
							  'text': this.listMerchantData[i].merchantname
							});
						  }
					}
				}, error => {
					console.error(error)
				})
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/daywisestockreport/daywisestockreport.component.js